module.exports = __webpack_public_path__ + "static/media/gd.a84d14e5.jpg";